import { cn } from '@/utils/cn';

export const toastStyles = {
	container: (isExiting: boolean) =>
		cn(
			'flex items-start gap-2 w-[360px] min-w-[170px] p-3 bg-white border border-[#e9e9f5] rounded-xl shadow-[0_8px_16px_0_rgba(106,105,119,0.08)]',
			isExiting
				? 'animate-[slideOutRight_200ms_ease-in_forwards]'
				: 'animate-[slideInRight_200ms_ease-out]'
		),
	iconSlot: 'shrink-0',
	body: 'flex-1 min-w-0 flex flex-col font-[Figtree,sans-serif] text-sm',
	title: 'text-[#2e2e3a] leading-[1.4] break-words font-normal',
	description: 'text-[#6a6977] leading-[1.4] break-words',
	actionButton: 'shrink-0 text-[#e22446] text-sm font-bold font-[Figtree,sans-serif] bg-transparent border-none cursor-pointer whitespace-nowrap',
	closeButton: 'shrink-0 flex items-center justify-center w-5 h-5 bg-transparent border-none cursor-pointer rounded hover:bg-[#f5f5fa] transition-colors'
} as const;
